<app-ravi-navbar ></app-ravi-navbar>
<br><br><br><br><br>
<router-outlet></router-outlet>
<app-footer></app-footer>